export default __webpack_public_path__ + "static/new7-e78091be7248c356c0f0faabb01f08d6.mp4";